import TextField from "@mui/material/TextField";
import { TextFieldProps } from "@mui/material";

type MyInputProps = TextFieldProps & {
  dir?: "rtl" | "ltr";
};

export default function MyInput(props: MyInputProps) {
  const { dir = "ltr", sx, ...rest } = props;

  const isRTL = dir === "rtl";

  return (
    <TextField
      {...rest}
      dir={dir}
      fullWidth
      sx={{
        "& .MuiInputBase-input": {
          textAlign: isRTL ? "right" : "left",
        },

        "& .MuiInputLabel-root": {
          left: isRTL ? "auto" : 0,
          right: isRTL ? (props.variant === "standard" ? 0 : 25) : "auto",
          transformOrigin: isRTL ? "top right" : "top left",
          fontFamily: "inherit",
          fontSize: 14,
        },

        "& .MuiInputLabel-root.Mui-focused": {
          color: "var(--primary)",
        },

        "& .MuiInputLabel-root.Mui-error": {
          color: "#d32f2f",
        },

        // OUTLINED
        "& .MuiOutlinedInput-root": {
          "& fieldset": {
            borderColor: "#e0e0e0",
          },

          "&:hover fieldset": {
            borderColor: "var(--primary)",
          },

          "&.Mui-focused fieldset": {
            borderColor: "var(--primary)",
            borderWidth: "2px",
          },

          "&.Mui-error fieldset": {
            borderColor: "#d32f2f",
          },

          "&.Mui-error:hover fieldset": {
            borderColor: "#d32f2f",
          },

          "&.Mui-error.Mui-focused fieldset": {
            borderColor: "#d32f2f",
            borderWidth: "2px",
          },
        },

        "& .MuiOutlinedInput-notchedOutline legend": {
          textAlign: isRTL ? "right" : "left",
        },

        // FILLED
        "& .MuiFilledInput-root": {
          backgroundColor: "#f5f5f5",

          "&:before": {
            borderBottom: "1px solid #ccc",
          },

          "&:hover:not(.Mui-disabled):before": {
            borderBottom: "1px solid var(--primary)",
          },

          "&:after": {
            borderBottom: "2px solid var(--primary)",
          },

          "&.Mui-error:before": {
            borderBottom: "1px solid #d32f2f",
          },

          "&.Mui-error:hover:not(.Mui-disabled):before": {
            borderBottom: "1px solid #d32f2f",
          },

          "&.Mui-error:after": {
            borderBottom: "2px solid #d32f2f",
          },
        },

        // STANDARD
        "& .MuiInput-root": {
          "&:before": {
            borderBottom: "1px solid #ccc",
          },

          "&:hover:not(.Mui-disabled):before": {
            borderBottom: "1px solid var(--primary)",
          },

          "&:after": {
            borderBottom: "2px solid var(--primary)",
          },

          "&.Mui-error:before": {
            borderBottom: "1px solid #d32f2f",
          },

          "&.Mui-error:hover:not(.Mui-disabled):before": {
            borderBottom: "1px solid #d32f2f",
          },

          "&.Mui-error:after": {
            borderBottom: "2px solid #d32f2f",
          },
        },

        "& .MuiFormHelperText-root": {
          textAlign: isRTL ? "left" : "right",
          marginLeft: isRTL ? 0 : "auto",
          marginRight: isRTL ? "auto" : 0,
        },

        ...sx,
      }}
    />
  );
}
